import { LegalEntityDto } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { BaseLegalEntityFormFieldNames } from 'shared/enums/baseLegalEntityFormFieldNames';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { LegalEntityContactFormValues } from 'features/new-actor/types/legalEntityContactFormValues';
import { LegalEntityFormValues } from 'features/new-actor/types/optim/legalEntityFormValues';
import { mapLegalEntityContact } from './mapLegalEntityContact';
import { normalizeCountryCode } from './normalizeCountryCode';

export function mapLegalEntity(
  values: LegalEntityDto,
  referentialsData: any
): Partial<LegalEntityFormValues> {

  const getLegalFormCode = (id?: string | null) => {
    const data = referentialsData[ReferentialKey.LegalForm].find((item: any) => item.id === id);
    return data ? (data.code as string) : undefined;
  };

  const {
    id,
    companyName,
    rcp,
    legalFormId,
    rcsNumber,
    rcsCity,
    oriasNumber,
    capital,
    registrationNumber,
    address,
    phone,
    email,
    naturalPersons,
  } = values;

  let contacts: LegalEntityContactFormValues[] = []
  if (naturalPersons)
    contacts = naturalPersons.map(naturalPerson => mapLegalEntityContact(naturalPerson, referentialsData))

  return {
    id,
    [LegalEntityFormFieldNames.CompanyName]: companyName,
    [PersonalInformationFieldNames.Email]: email,
    [PersonalInformationFieldNames.Phone]: phone,
    [BaseLegalEntityFormFieldNames.Rcp]: rcp || undefined,
    [BaseLegalEntityFormFieldNames.LegalReason]: getLegalFormCode(legalFormId),
    [BaseLegalEntityFormFieldNames.RcsCity]: rcsCity,
    [BaseLegalEntityFormFieldNames.RcsNumber]: rcsNumber,
    [BaseLegalEntityFormFieldNames.OriasNumber]: oriasNumber || undefined,
    [BaseLegalEntityFormFieldNames.Capital]: capital,
    [BaseLegalEntityFormFieldNames.RegistrationNumber]: registrationNumber,
    [AddressFormFieldNames.Address]: address.line1 || '',
    [AddressFormFieldNames.City]: address.city,
    [AddressFormFieldNames.AdditionalAddress]: address.line2 || address.line3 || undefined,
    [AddressFormFieldNames.PostalCode]: address.zipCode,
    [AddressFormFieldNames.Country]: normalizeCountryCode(address.country, referentialsData),
    // place_id / coordonnées doivent être rechargés pour ne pas invalider l'adresse en édition.
    [AddressFormFieldNames.GooglePlaceId]: address.googlePlaceId ?? undefined,
    [AddressFormFieldNames.Latitude]: address.latitude,
    [AddressFormFieldNames.Longitude]: address.longitude,
    [LegalEntityFormFieldNames.Contacts]: contacts,
  };
}
